import React from "react";
import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";

class TwoFAValidationWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            twoFactorAuthenticationCode: null,
            addDevice: false,
            deviceName: null,
            deviceType: "P"
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    loginVerifyFn() {
        if (event) {
            event.preventDefault();
        }

        var thisComponent = this;
        const deviceName = thisComponent.state.addDevice && thisComponent.state.deviceName && thisComponent.state.deviceName !== "" ?
            thisComponent.state.deviceType.toUpperCase() + "_" + thisComponent.state.deviceName : null;

        thisComponent.props.onLogInVerify({
            twoFactorAuthenticationCode: thisComponent.state.twoFactorAuthenticationCode,
            deviceName: deviceName
        });
    }

    closePopup() {
        this.setState({
            twoFactorAuthenticationCode: null,
            addDevice: false,
            deviceName: null,
            deviceType: "P"
        });

        this.props.onHideWidget();
    }

    handleInputChange(e) {
        if (e.target.name === "addDevice") {
            this.setState({ addDevice: !this.state.addDevice });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    render() {
        return (
            <ErrorBoundary componentName="TwoFAValidationWidget">
                {this.props.showWidget &&
                    <div className="loginWidget">
                        <div className="mask">
                        </div>
                        <form name="twoFAVerifyForm" id="twoFAVerifyForm" onSubmit={this.loginVerifyFn.bind(this)}>
                            <div className="row mb-3">
                                <div className="col-10">
                                    <h1>{window.resources_en.TwoFactorAuthenticationLoginWindowTitle}</h1>
                                </div>
                                <div className="col-2 text-right">
                                    <a href="#" className="closePopup" onClick={this.closePopup.bind(this)}>X</a>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-3">
                                    <img src="../clientApp/login/images/g2fa.png" />
                                </div>
                                <div className="col">
                                    <p>{window.resources_en.TwoFactorAuthenticationLoginWindowDescription}</p>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col form-group">
                                    <input id="twoFactorAuthenticationCode" name="twoFactorAuthenticationCode" type="text" className="form-control text-center"
                                        placeholder="_ _ _ _ _ _" onChange={this.handleInputChange} required="required" />
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-1 form-group">
                                    <input id="addDevice" name="addDevice" type="checkbox" className="form-check"
                                        onChange={this.handleInputChange} />
                                </div>
                                <div className="col form-group">
                                    <strong>{window.resources_en.TwoFactorAuthenticationLoginWindowThisIsATrustedDevice}</strong>
                                </div>
                            </div>
                            {this.state.addDevice &&
                                <div className="row align-items-center">
                                    <div className="col form-group">
                                        <input id="deviceName" name="deviceName" type="text" className="form-control"
                                            placeholder={window.resources_en.TwoFactorAuthenticationLoginWindowDeviceNamePlaceholder} required="required"
                                            onChange={this.handleInputChange} />
                                    </div>
                                </div>}
                            {this.state.addDevice &&
                                <div className="row align-items-center">
                                    <div className="col form-group">
                                        <select id="deviceType" name="deviceType" className="form-control"
                                            onChange={this.handleInputChange} >
                                            <option value="P">{window.resources_en.TwoFactorAuthenticationLoginWindowDeviceTypePhone}</option>
                                            <option value="T">{window.resources_en.TwoFactorAuthenticationLoginWindowDeviceTypeTablet}</option>
                                            <option value="L">{window.resources_en.TwoFactorAuthenticationLoginWindowDeviceTypeLaptop}</option>
                                            <option value="PC">{window.resources_en.TwoFactorAuthenticationLoginWindowDeviceTypeDesktop}</option>
                                        </select>
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col form-group">
                                    <button type="submit" id="twoFAVerifyBtn" value="twoFAVerifyBtn" className="btn btn-primary w-100"> {window.resources_en.TwoFactorAuthenticationLoginWindowVerify} </button>
                                </div>
                            </div>
                        </form>
                    </div>
                }
            </ErrorBoundary>
        );
    }
}

export { TwoFAValidationWidget };